import { render, staticRenderFns } from "./HomeTablet.vue?vue&type=template&id=415423d8"
import script from "./HomeTablet.vue?vue&type=script&lang=js"
export * from "./HomeTablet.vue?vue&type=script&lang=js"
import style0 from "./HomeTablet.vue?vue&type=style&index=0&id=415423d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports